import { FC } from "react";

const WarningNew: FC = () => {
  return (
    <>
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.50065 0.583496C4.13065 0.583496 0.583984 4.13016 0.583984 8.50016C0.583984 12.8702 4.13065 16.4168 8.50065 16.4168C12.8707 16.4168 16.4173 12.8702 16.4173 8.50016C16.4173 4.13016 12.8707 0.583496 8.50065 0.583496ZM9.29232 12.4585H7.70898V10.8752H9.29232V12.4585ZM9.29232 9.29183H7.70898V4.54183H9.29232V9.29183Z" fill="#E52514"/>
        </svg>
    </>
  )
};

export default WarningNew;